import { mapState, mapGetters, mapActions } from 'vuex'

import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'


export default {

	props: {
		population: {
			type: Array,
			required: true
		}
	},

	methods: {
		formatDate,
		formatDateTime,

		getIconImage(card) {
			return require('./image/' + card + '.png')
		}
	},

	computed: {
		...mapGetters('provider', [
			'getProvider'
		]),
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),

		providerProfiles() {
			if (this.getProvider)
				return this.getProvider.profile
		}
	}
}
